import { SessionService } from "./shared/services/session.service";
import {
  BrowserModule,
  DOCUMENT,
  platformBrowser,
} from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from "@angular/platform-browser/animations";

import { AppComponent } from "./app.component";
import { MatDialogModule } from "@angular/material/dialog";
import {
  MatButtonModule,
  MatSnackBarModule,
  MatIconModule,
  MatInputModule,
  MatFormFieldModule,
  MatOptionModule,
  MatSelectModule,
  MatProgressSpinnerModule,
  MatTabsModule,
} from "@angular/material";
import { LoginComponent } from "./login/login.component";
import { RegistrationComponent } from "./registration/registration.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BackendApiService } from "./shared/services/backend-api.service";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ConstantService } from "./shared/constant/constant.service";
import { EqualValidator } from "./registration/equal-validator.directive";
import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
import { User } from "./shared/class/user";
import { PaymentComponent } from "./payment/payment.component";
import { PrivacyComponent } from "./privacy/privacy.component";
import { TAndCComponent } from "./t-and-c/t-and-c.component";
import { VideoJsComponent } from "./video-js/video-js.component";
import { SlideshowModule } from "ng-simple-slideshow";
import { OwlModule } from "ngx-owl-carousel";
import { RouterModule, Routes } from "@angular/router";
import { HomePageComponent } from "./home-page/home-page.component";
import { PackageComponent } from "./package/package.component";
import { MessageserviceService } from "./shared/services/messageservice.service";
import { MedialistComponent } from "./medialist/medialist.component";
import { FaqComponent } from "./faq/faq.component";
import { AddHeaderInterceptor } from "./shared/AddHeaderInterceptor";
const routes: Routes = [
  { path: "", component: HomePageComponent },
  { path: "livetv", component: VideoJsComponent },
  { path: "faq", component: FaqComponent },
];

// AoT requires an exported function for factories
export const createTranslateLoader = (http: HttpClient) => {
  /* for development
  return new TranslateHttpLoader(
      http,
      '/start-angular/SB-Admin-BS4-Angular-6/master/dist/assets/i18n/',
      '.json'
  ); */
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
};
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegistrationComponent,
    EqualValidator,
    PaymentComponent,
    PrivacyComponent,
    TAndCComponent,
    VideoJsComponent,
    HomePageComponent,
    PackageComponent,
    MedialistComponent,
    FaqComponent,
  ],
  imports: [
    BrowserModule,
    MatDialogModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    MatButtonModule,
    MatSnackBarModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SlideshowModule,
    Ng4LoadingSpinnerModule,
    OwlModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    RouterModule.forRoot(routes),
  ],
  providers: [
    BackendApiService,
    ConstantService,
    User,
    SessionService,
    AppComponent,
    MessageserviceService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHeaderInterceptor,
      multi: true,
      deps: [SessionService],
    },
  ],
  bootstrap: [AppComponent],

  entryComponents: [
    AppComponent,
    LoginComponent,
    RegistrationComponent,
    PaymentComponent,
    PrivacyComponent,
    TAndCComponent,
    VideoJsComponent,
    MedialistComponent,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts